import {
  Card as MantineCard,
  CardProps as MantineCardProps,
  Stack,
  StackProps,
} from "@mantine/core"
import { DetailedHTMLProps, HTMLAttributes, ReactNode } from "react"

import styles from "./Card.module.css"

export type CardProps = {
  children: ReactNode
} & MantineCardProps &
  Omit<
    Omit<
      DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
      "ref"
    >,
    "component" | keyof MantineCardProps
  >
export const Card = ({ children, ...props }: CardProps) => {
  return (
    <MantineCard withBorder {...props} className={styles.card}>
      {children}
    </MantineCard>
  )
}

type CardHeaderProps = {
  children?: ReactNode
} & StackProps

Card.Header = ({ children, ...props }: CardHeaderProps) => {
  return (
    <Stack gap="var(--tfg-organism-padding-y)" {...props}>
      {children}
    </Stack>
  )
}

// Subcomponent for Card Body
type CardBodyProps = {
  children: ReactNode
} & StackProps

Card.Section = ({ children, ...props }: CardBodyProps) => {
  return (
    <Stack gap="var(--tfg-organism-padding-y)" {...props}>
      {children}
    </Stack>
  )
}
